import { User } from "../../models/user.model";
import { Office } from "../../models/office.model";
import { RequestMessage } from "../../models/request-message.model";

import { Button, TextInput, Comment } from "../../components";

export interface PatientCommunicationProps {
  messages: RequestMessage[] | null;
  onSubmit: () => void;
  isRequestArchived: boolean | undefined;
  isRequestCancelled: boolean | undefined;
  onMentionClick: () => void;
  currentOffice: Office | null;
  currentUser: User | null | undefined;
  readAction: (messageId: string, read: boolean) => void;
  isSubmitDisabled: boolean;
  inputValue: string;
  onChangeInput: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlurInput: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const PatientCommunication = ({
  messages,
  onSubmit,
  isRequestArchived,
  isRequestCancelled,
  onMentionClick,
  currentOffice,
  currentUser,
  readAction,
  isSubmitDisabled,
  inputValue,
  onChangeInput,
  onBlurInput,
}: PatientCommunicationProps) => {
  const getCommentFrom = (message: RequestMessage) =>
    currentUser?.userType === "patient"
      ? currentOffice?.name || ""
      : message?.senderName || `${message?.sender?.firstName ?? ""} ${message?.sender?.lastName ?? ""}`;

  const renderMessages = () => {
    if (messages && messages.length) {
      return (
        <div>
          {messages?.map(message => (
            <Comment
              onMentionClick={onMentionClick}
              time={message.createdDate}
              from={getCommentFrom(message)}
              key={message.requestMessageId}
              text={message.message}
              disableMentions
              comment={message}
              showReadAction={message?.sender?.userId !== currentUser?.userId && !isRequestArchived}
              readAction={readAction}
            />
          ))}
        </div>
      );
    } else if (isRequestCancelled || isRequestArchived) {
      return "-";
    }
  };

  const renderForm = () => {
    if (!isRequestCancelled && !isRequestArchived) {
      return (
        <div className="text-right">
          <TextInput
            isTextArea
            extraInputClass="h-40"
            placeholder="Send external message to patient"
            value={inputValue}
            onChangeFunc={onChangeInput}
            onBlur={onBlurInput}
          />
          <Button
            text="Send"
            onClick={() => {
              onSubmit();
            }}
            disabled={isSubmitDisabled}
            name="send-patient-comment"
            className="mt-4 px-5"
            width="fit"
          />
        </div>
      );
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-3">
        <p className="text-base font-semibold">Patient Communication</p>
      </div>
      <div
        className={`w-full ${
          (messages && messages.length) || (!isRequestCancelled && !isRequestArchived) ? "p-6 rounded-lg border border-docsigna-pink" : ""
        }`}
      >
        {renderMessages()}
        {renderForm()}
      </div>
    </>
  );
};

export default PatientCommunication;
